/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { faCalculator } from '@fortawesome/free-solid-svg-icons/faCalculator'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useFormContext } from '@jalik/react-form'
import { useCallback } from 'react'
import { useIntl } from 'react-intl'
import AmountPercentageCalculatorPopover from '../mandate/AmountPercentageCalculatorPopover'
import PriceField, { PriceFieldProps } from './PriceField'
import { ActionIcon } from '@mantine/core'

export type AgencyFeesFieldProps = PriceFieldProps & {
  amount?: number,
  disabled?: boolean,
  total?: number,
  value?: number
}

function AgencyFeesField (props: AgencyFeesFieldProps) {
  const intl = useIntl()
  const { setValue } = useFormContext()
  const { amount, disabled, name = 'agencyFees', total, value, ...others } = props

  const handleValidate = useCallback((val: number) => {
    setValue(name, Math.round(val))
  }, [name, setValue])

  return (
    <PriceField
      label={intl.formatMessage({
        id: 'agency_fees',
        defaultMessage: 'Honoraires d\'agence'
      })}
      {...others}
      disabled={disabled}
      name={name}
      value={value}
      leftSection={(
        <AmountPercentageCalculatorPopover
          amount={amount}
          total={total}
          onValidate={handleValidate}
        >
          <ActionIcon disabled={disabled || total == null}>
            <FontAwesomeIcon
              fixedWidth
              icon={faCalculator}
            />
          </ActionIcon>
        </AmountPercentageCalculatorPopover>
      )}
    />
  )
}

export default AgencyFeesField
